export default __webpack_public_path__ + "static/media/copyLogoSelect.b115dff5.svg";